module.exports = __webpack_public_path__ + "img/cat-hd.192bb36d.png";